import { Link } from "react-router-dom";

const CATEGORIES = [
  { slug: "administratif", label: "Administratif" },
  { slug: "finance", label: "Finance" },
  { slug: "sante", label: "Santé" },
  { slug: "auto", label: "Auto & Transport" },
  { slug: "famille", label: "Famille" },
  { slug: "vie-pratique", label: "Vie Pratique" },
];

const GUIDES = [
  { slug: "guide-demarches-administratives-maroc", label: "Guide Admin" },
  { slug: "guide-visa-maroc", label: "Guide Visa" },
  { slug: "guide-sante-maroc", label: "Guide Santé" },
  { slug: "guide-auto-transport-maroc", label: "Guide Auto" },
  { slug: "guide-famille-maroc", label: "Guide Famille" },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <img
                src="/brand/logo-horizontal-light.svg"
                alt="Maroc Pratique"
                className="h-9 w-auto"
                width="185"
                height="36"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Le guide pratique des Marocains. Démarches administratives, prix, délais et conseils concrets.
            </p>
            <p className="text-xs text-slate-600 mt-2">
              Site indépendant · Non officiel · Informations à titre indicatif
            </p>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Catégories
            </h3>
            <ul className="space-y-2">
              {CATEGORIES.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/categorie/${cat.slug}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                    data-testid={`footer-cat-${cat.slug}`}
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Guides Pratiques
            </h3>
            <ul className="space-y-2">
              {GUIDES.map((guide) => (
                <li key={guide.slug}>
                  <Link
                    to={`/pilier/${guide.slug}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                    data-testid={`footer-guide-${guide.slug}`}
                  >
                    {guide.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Informations
            </h3>
            <p className="text-xs text-slate-500 leading-relaxed">
              Les informations publiées sur MarocPratique sont données à titre indicatif.
              Consultez toujours les sources officielles (portail.maroc.ma) pour les démarches
              administratives. Les prix indiqués sont des estimations pouvant varier.
            </p>
            <ul className="mt-4 space-y-1">
              <li>
                <Link to="/contact" className="text-xs text-slate-500 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-xs text-slate-500 hover:text-white transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-xs text-slate-500 hover:text-white transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
            <p className="text-xs text-slate-600 mt-4">
              &copy; {new Date().getFullYear()} MarocPratique.com — Tous droits réservés
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
